// The gems page's prices from the backend (promptchan-backend GET /api/gem-prices, myapp/pricing.py; with room 2's
// switch on, v2's GET /v2/catalogue/packs in the same shape: src/lib/api/billing.ts): what a checkout charges this
// account, its price per gem, and what each pack saves against the smallest. The page keeps its own copy
// (src/lib/gem-packs.js) for the moment before the answer arrives, or when it cannot be had.
import { gemPrices } from './api/billing.ts'

/** The answer, or null when it cannot be had (the page then shows its own copy). */
export async function fetchGemPrices(token, ask = gemPrices) {
  try {
    const response = await ask(token)
    if (!response.ok) return null
    const answer = await response.json()
    return Array.isArray(answer?.packs) ? answer : null
  } catch {
    return null
  }
}

/** The page's packs with the backend's prices in: `price` the list price, `discountedPrice` this account's half price.
 *  Without an answer, the packs as they are. */
export function withServerPrices(packs, answer) {
  if (!answer?.packs?.length) return packs
  const byId = Object.fromEntries(answer.packs.map((p) => [p.gem_id, p]))
  return packs.map((pack) => {
    const server = byId[pack.gemId]
    if (!server) return pack
    return {
      ...pack,
      price: server.list_price.toFixed(2),
      discountedPrice: server.price.toFixed(2),
      // v2's sale (`sale`): its price is the account's own, shown where the page shows a Black Friday price.
      ...(answer.sale ? { blackFridayPrice: server.price.toFixed(2) } : {}),
    }
  })
}
